import ScrollTrigger from 'gsap/ScrollTrigger'

export function isInViewport (el, startRatio = 0.9) {
  const rect = el.getBoundingClientRect()
  const windowHeight = window.innerHeight || document.documentElement.clientHeight

  return rect.top <= windowHeight * startRatio && rect.bottom >= 0
}

export function createOnceOnEnter ({ trigger, start = 'top 90%', onEnter }) {
  let called = false

  const fire = () => {
    if (called) {
      return
    }

    called = true
    onEnter()
  }

  ScrollTrigger.create({
    trigger,
    start,
    once: true,
    onEnter: fire,
  })

  requestAnimationFrame(() => {
    if (isInViewport(trigger)) {
      fire()
    }
  })

  return fire
}
